import { Select } from "@light-technology/components";
import { Lightning01 } from "@untitledui/icons";
import type { Key } from "react";
import { USAGE_KWH_ITEMS, type UsageKwh } from "./common";

const ITEMS = USAGE_KWH_ITEMS.map((item) => ({
  id: String(item.id),
  label: item.label,
}));

type UsageKwhSelectProps = {
  value: UsageKwh;
  onChange: (value: UsageKwh) => void;
};

export const UsageKwhSelect = ({ value, onChange }: UsageKwhSelectProps) => {
  return (
    <Select
      label="Avg. monthly usage"
      items={ITEMS}
      value={String(value)}
      onChange={(key: Key | null) => {
        if (key !== null) onChange(Number(key) as UsageKwh);
      }}
      placeholderIcon={Lightning01}
      isRequired
      className="min-w-40"
      aria-label="Select usage kWh"
    >
      {(item) => <Select.Item id={item.id}>{item.label}</Select.Item>}
    </Select>
  );
};
